/* eslint-disable radix */
/* eslint-disable no-prototype-builtins */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import {
  BrowserRouter, Route, Switch, Redirect,
} from 'react-router-dom';
// import { createStore } from 'redux';
// import { Provider } from 'react-redux';
// import reducers from './reducers';
import QRCodeScanner from '../Components/QRCodeScanner';
import StudentDetails from '../Components/StudentDetails';
// import ErrorPage from '../Components/ErrorPage';
import StudentSchedule from '../Components/StudentSchedule';
import Tardies from '../Components/Tardies';
import Detentions from '../Components/Detentions';
import QRScanningForPrinter from '../Components/QRScanningForPrinter';
import ComingSoon from '../Components/ComingSoon';
import StudentId from '../Components/StudentId';
import Login from '../Components/Login';
import { MainContainer } from '../Components/StyledComponents';
import loader from '../images/loading.gif';
import '../App.scss';
import { getStudentDetails, deviceStorage } from '../services/calls';
import userInfoObjectCreator from '../services/userInfoObjectCreator';
import deviceInfoGenerator from '../services/deviceInfoGenerator';
import { getSchoolHostname, isGoogleLoginSchool } from '../services/getSchoolHostname';
import LoginForBrihimgham from '../Components/LoginForBrihimgham';
import NoAccessWrapper from '../View/NoAccessWrapper';
import PrivateRoute from '../View/PrivateRoute';
import base64Conversion from '../services/base64conversion';
import studentActivationInfo from '../services/studentActivationInfo';

require('dotenv').config();

const location = window.location.href;
const domainName = location.split('//')[1].split('/')[0];
// const store = createStore(reducers);
export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qrCode: null,
      defferedPrompt: null,
      loading: true,
      errorMsg: '',
    };
    this.conditionalRedirection = this.conditionalRedirection.bind(this);
    this.savingToCache = this.saveToCache.bind(this);
  }

  async componentDidMount() {
    const token = location.split('//')[1].split('/')[1];
    const domainNameWithoutId = domainName.split('-')[1];
    /* const domainNameWithoutId = 'tesths.360isuite.com'; */
    const pages = ['studentDetails', 'noAccess', 'scanQR', 'tardies', 'detentions',
      'studentSchedule', 'comingSoon', 'studentID', 'login'];
    if (token && pages.indexOf(token) === -1) {
      /* this.setState({ loading: false }); */
      this.getStudentDetail(token, domainNameWithoutId)
        .then(this.conditionalRedirection)
        .then(async () => this.redirectToStudentPage())
        .then(() => setTimeout(() => this.setState({ loading: false }), 2000))
        .catch((err) => {
          //  // console.log(err);
          if (err) {
            this.setState({
              loading: false,
              errorMsg: 'Something went wrong',
            });
          }
        });
    } else {
      this.promptListener = window.addEventListener(
        'beforeinstallprompt',
        async (e) => {
          e.preventDefault();
          if (
            localStorage.getItem('appInstalled') === 'true'
            && localStorage.getItem('justInstalled') === 'false'
            && !window.matchMedia('(display-mode: standalone)').matches
          ) {
            await caches
              .keys()
              .then((keyList) => {
                Promise.all(keyList.map((key) => caches.delete(key)));
              })
              // .catch((err) =>  // console.log(err));
            localStorage.removeItem('appInstalled');
            localStorage.removeItem('studentDetails');
            localStorage.removeItem('qrData');
            this.setState({ qrCode: null });
          }
          this.setState({ defferedPrompt: e });
          localStorage.setItem('justInstalled', false);
        },
      );
      const qrData = JSON.parse(localStorage.getItem('qrData'));
      if (qrData) this.setState({ qrCode: 1, loading: false });
      if (isGoogleLoginSchool()) {
        this.setState({
          loading: false,
        });
      }
      fetch(process.env.REACT_APP_API_QR_DATA)
        .then((response) => response.json())
        .then((data) => {
          if (data.hasOwnProperty('school_name')) {
            this.setState({ qrCode: 2 });
          }
          this.setState({ loading: false });
        })
        .catch((err) => {
           // console.log(err);
          this.setState({ loading: false });
        });
      this.appInstalled = window.addEventListener('appinstalled', () => {
        localStorage.setItem('appInstalled', true);
        localStorage.setItem('justInstalled', true);
      });
      const studentDetails = JSON.parse(localStorage.getItem('studentDetails'));
      
      if (studentDetails
        && studentDetails.student_photo_url !== '' && studentDetails.student_photo_url !== ' ') {
        const objToBeSent = {
          school_code: studentDetails.school_code,
          student_id: studentDetails.student_id,
          student_no: studentDetails.student_no,
        };
        studentActivationInfo(objToBeSent);
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async getStudentDetail(token, loc) {
    return getStudentDetails(token, loc).then((res) => res.json());
  }

  getRegistrationData(res) {
    if (res.status === 200) {
      return Promise.resolve();
    }
    localStorage.removeItem('studentDetails');
    localStorage.removeItem('qrData');
    return this.deleteFromCache;
  }

  deleteFromCache() {
    return Promise.resolve(
      fetch(process.env.REACT_APP_API_QR_DATA, {
        method: 'POST',
        body: JSON.stringify({}),
      }).then(() => {
         // console.log('Deleted from cache');
      }),
    );
  }

  sendDeviceInfo() {
    const userInfo = JSON.parse(localStorage.getItem('studentDetails'));
    const [os, device] = deviceInfoGenerator();
    return Promise.resolve(
      deviceStorage(
        parseInt(userInfo.student_id),
        userInfo.student_no,
        userInfo.school_code,
        os,
        device,
      ).then((res) => res.json()),
    );
  }

  // eslint-disable-next-line class-methods-use-this
  saveToCache(result) {
    const header = base64Conversion();
    return Promise.resolve(
      fetch(process.env.REACT_APP_API_QR_DATA, {
        method: 'POST',
        body: JSON.stringify(result),
        headers: {
          Authorization: header,
        },
      }).then(() => {
         // console.log('Saved to Cache');
      }),
    );
  }

  redirectToStudentPage() {
    /* When our request hits withs a token value,
    after the whole processing of saving data to cache
    and sending it back to backend, we will redirect the
    request to the student details page */

    return Promise.resolve(
      window.location.assign(`https://${domainName}/studentDetails`),
    );
  }

  conditionalRedirection(result) {
    if (result.status === 200) {
      const newRes = {
        first_name: result.data.fn,
        last_name: result.data.ln,
        student_id: result.data.id,
        student_no: result.data.no,
        school_name: result.data.sch,
        grade: result.data.grd,
        school_logo: result.data.logo,
        student_photo_url: result.data.photo,
        school_code: result.data.code,
        show_id: result.data.showId,
        direct_url: result.data.dUrl,
        lpass: result.data.lpass,
      };
      const userInfo = userInfoObjectCreator(newRes);
      localStorage.setItem('qrData', JSON.stringify(newRes));
      localStorage.setItem('studentDetails', JSON.stringify(userInfo));
      return this.saveToCache(newRes)
        .then(() => this.saveToCache(newRes))
        .then(this.sendDeviceInfo)
        .then(this.getRegistrationData);
    }
    return Promise.resolve();
  }

  render() {
    const {
      qrCode, defferedPrompt, loading, errorMsg,
    } = this.state;
    const className = getSchoolHostname(window.location.hostname);
    const schoolHasGoogleLogin = isGoogleLoginSchool();
     // console.log(isGoogleLoginSchool());
    // const userInfo = JSON.parse(localStorage.getItem('studentDetails'));
    let routes;

    if (loading) {
      return (
        <MainContainer className="student-detail-page">
          <img src={loader} className="menu-loader" alt="Loading ..." />
        </MainContainer>
      );
    }

    if (errorMsg) {
      return (
        <MainContainer className="student-detail-page">
          <div className="error-wrapper">
            <p className="error-page-text" style={{ color: 'red' }}>
              {errorMsg}
            </p>
          </div>
        </MainContainer>
      );
    }

    if ((qrCode === 1 || qrCode === 2) && !schoolHasGoogleLogin) {
      routes = (
        <Switch>
          <Route path="/" component={StudentDetails} exact />
          <Route
            path="/studentDetails"
            render={(props) => (
              // eslint-disable-next-line react/jsx-props-no-spreading
              <StudentDetails {...props} prompt={defferedPrompt} />
            )}
          />
          <Route path="/studentSchedule" component={StudentSchedule} />
          <Route
            path="/studentID"
            render={(props) => (
              // eslint-disable-next-line react/jsx-props-no-spreading
              <StudentId {...props} prompt={defferedPrompt} />
            )}
          />
          <Route path="/noAccess" component={NoAccessWrapper} />
          <Route path="/comingSoon" component={ComingSoon} />
          <Route path="/tardies/:id" component={Tardies} />
          <Route path="/detentions" component={Detentions} />
          <Route path="/printing" component={QRScanningForPrinter} />
          <Route path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
      );
    } else if (schoolHasGoogleLogin) {
      routes = (
        <Switch>
          <Route
            path="/login"
            component={className === 'mybchsid' ? LoginForBrihimgham : Login}
          />
          <PrivateRoute
            path="/"
            exact
            component={StudentId}
            prompt={defferedPrompt}
          />
          <PrivateRoute
            path="/noAccess"
            exact
            component={NoAccessWrapper}
          />
          <Route path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
      );
    } else {
      routes = (
        <Switch>
          <Route exact path="/" component={QRCodeScanner} />
          {/* <Route path="/scanQR" component={QRCodeScanner} /> */}
          {/* <Route path="/login" component={Login} /> */}
          <Route
            path="/studentDetails"
            render={(props) => (
              // eslint-disable-next-line react/jsx-props-no-spreading
              <StudentDetails {...props} prompt={defferedPrompt} />
            )}
          />
          <Route path="/studentSchedule" component={StudentSchedule} />
          <Route
            path="/studentID"
            render={(props) => (
              // eslint-disable-next-line react/jsx-props-no-spreading
              <StudentId {...props} prompt={defferedPrompt} />
            )}
          />
          <Route path="/noAccess" component={NoAccessWrapper} />
          <Route path="/comingSoon" component={ComingSoon} />
          <Route path="/tardies/:id" component={Tardies} />
          <Route path="/detentions" component={Detentions} />
          <Route path="/printing" component={QRScanningForPrinter} />
          <Route path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
      );
    }
    return (
      <div className={className}>
        {/* <p>{localStorage.getItem('studentDetails')}</p> */}
        <BrowserRouter>
          {routes}
        </BrowserRouter>
      </div>
    );
  }
}
